console.log("issue-product-list.js");

// 获取商品信息的函数
async function getProductByHandle(handle) {
  const query = `
            query getCollectionProducts($handle: String!, $country: CountryCode!) @inContext(country: $country) {
  collection(handle: $handle) {
    id
    title
    products(first: 100, sortKey: MANUAL) {
      edges {
        node {
          id
          title
          handle
          featuredImage {
            url
            altText
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          metafields(identifiers: [{namespace: "custom", key: "title_zh_tw"}]) {
            id
            namespace
            key
            value
            type
          }
        }
      }
    }
  }
}
`;

  const variables = {
    handle: handle,
    country: window.Shopify.country
  };

  return fetchGraphQL(query, variables)
    .then((data) => {
      const product = data.collection.products.edges;
      console.log(product);
      return product;
    })
    .catch((error) => {
      console.error("Error retrieving product:", error);
    });
}

function fetchGraphQL(query, variables = {}) {
  const endpoint =
    "https://store.magnifissance.com/api/2023-04/graphql.json";
  const accessToken = "6dd485b7997c77cc4794f50f5ff2ae3b"; // 替换为您的访问令牌

  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((response) => response.json())
    .then((data) => data.data)
    .catch((error) => {
      console.error("GraphQL Error:", error);
    });
}

const createTemplate = (prod, prod_handle, is_zh_tw) => {
  const prod_title = is_zh_tw ? (prod.node.metafields[0]? prod.node.metafields[0].value : prod.node.title) : prod.node.title;
   const prod_url = is_zh_tw ? "/products/" + prod.node.handle+"?lng=zh-tw" : "/products/" + prod.node.handle;
  let _html = `<div class="one-fourth medium-down--one-half column show-btnwish thumbnail product__thumbnail product__gridItem thumbnail__hoverOverlay--false" style="">
  <div class="product-wrap">
      <div class="image__container product__imageContainer" style=" max-width:650px; ">
        <div class="banner_holder bannerPosition--left">
        </div>
        <a href="${prod_url}" class="hidden-product-link" tabindex="0">${prod_title}</a>
<div class="image-element__wrap" style=" max-width: 650px;">
  <img alt="" src="${prod.node.featuredImage.url}">
</div>
<noscript class="noscript">
  <img src="${prod.node.featuredImage.url}" alt="" class="primary swap noscript">
</noscript>
</div>
<div class="thumbnail__caption textAlign--center">
      <div class="product-details">
<span class="brand">Magnifissance Store</span>
<span class="title">${prod_title}</span>
<span class="price ">
<span class="money">
${formatPrice(prod.node.priceRange.minVariantPrice.amount, prod.node.priceRange.minVariantPrice.currencyCode)}</span></span></div>

  <i class="far fa-heart pl-wish-btn seller-wishlist" aria-hidden="true" title="add to wish list" data-handle="${prod.node.handle}"></i><span class="sr-only">add to wish list</span>
    </div>
  </div>

  <div class="item_btnwish__borderOverlay"></div>
<div class="item_btnwish"><div class="bw-info"></div><div class="bw-btn"><i class="far fa-heart" aria-hidden="true"></i><i class="fas fa-shopping-cart" aria-hidden="true"></i></div></div>
</div>
`
  return _html;
}

async function getIssueProductList() {
  const is_zh_tw = window.location.href.includes("lng=zh-tw");
  const _prodInfolist = await getProductByHandle('magazine');
  console.log(_prodInfolist);
  const _issueProductList = document.getElementById('issue-list-product');
  let _html = "";
  _prodInfolist.forEach(function (item) {
    _html += createTemplate(item, 'magazine', is_zh_tw);
  });
  _issueProductList.innerHTML = _html;
}


//show price integer
function formatPrice(amount, currencyCode) {
  const currencySymbol = document.getElementById('CurrencySymbol').value;
  return currencySymbol + parseInt(amount) + ' ' + currencyCode;
}

getIssueProductList();

